export const FLYOUT_HEIGHT = 161;
export const FLYOUT_WIDTH = 212.8;
export const FLYOUT_CURSOR_MARGIN_X = 14;
export const FLYOUT_CURSOR_MARGIN_Y = 28;
